'use client';

import { useCallback, useContext } from 'react';
import DeferredStreamBoundary from '@/common/DeferredStreamBoundary';
import { DeferredRequestKey } from '~/constants/common/deferredRequests';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import type { PricingResult } from '~/server-props/vdp/getVehiclePricing';

export default function PricingDeferred({
  promise
}: {
  promise: Promise<PricingResult | undefined>;
}) {
  const { setPricingData, triggerFetchVehiclePricing } =
    useContext(UserVehicleContext);

  const onResolve = useCallback(
    (data: PricingResult | undefined) => {
      if (data) {
        setPricingData(data.response);
      } else {
        triggerFetchVehiclePricing();
      }
    },
    [setPricingData, triggerFetchVehiclePricing]
  );

  return (
    <DeferredStreamBoundary
      deferredKey={DeferredRequestKey.Pricing}
      onResolve={onResolve}
      promise={promise}
    />
  );
}
